import { For } from "solid-js"

export const BrandValues = (props) => {
  return (
    <div class="grid grid-cols-2 grid-auto gap-2 sm:gap-3 bg-[#F3E0D0] p-2 sm:p-3 text-2xs sm:text-sm font-semibold rounded-xl justify-center">
      <For each={props.values}>{(brandValue) => {
        console.log("brandValue icon: ", brandValue.icon);

        return (
          <div
            class="flex flex-1 items-center rounded-full bg-[#F6E5D7] border border-canvas gap-1"
            classList={{
              "p-1": brandValue.icon,
              "py-1 px-2": !brandValue.icon
            }}
          >
            <Show
              when={brandValue.icon}
            >
              <div
                class="rounded-full bg-canvas-light p-1 w-6 h-6 flex flex-none"
                innerHTML={brandValue.icon}
              />
            </Show>
            <div>{brandValue.title}</div>
          </div>
        )
      }}</For>

    </div>
  )
}

export const BrandValuesV2 = (props) => {
  return (
    <div class="grid grid-cols-3 grid-auto bg-canvas-depressed text-xs sm:text-sm justify-center divide-x divide-y divide-frame border border-frame">
      <For each={props.values}>{(brandValue) => (
        <div
          class="flex flex-1 items-center p-2 sm:p-3"
          classList={{
            "col-span-3 justify-around gap-1": brandValue.fullWidth == true,
            "flex-col justify-center text-center": brandValue.fullWidth != true
          }}
        >
          <Show
            when={brandValue.icon}
          >
            <div
              class="flex flex-none"
              classList={{
                "size-10 mx-0.5": brandValue.fullWidth == true,
                "w-6 h-6": brandValue.fullWidth != true
              }}
              innerHTML={brandValue.icon}
            />
          </Show>
          <div class="flex flex-col gap-1">
            <div class="font-semibold">{brandValue.title}</div>
            <Show
              when={brandValue.description}
            >
              {brandValue.description}
            </Show>
          </div>
        </div>
      )}</For>
    </div>
  )
}